/**
 * Утилиты для форматирования
 */

/**
 * Форматирует сумму денег
 * @param amount - сумма в рублях
 * @returns строка в формате с разделителями тысяч
 * @example formatMoney(1000) => "1 000 ₽"
 * @example formatMoney(0) => "0 ₽"
 */
export const formatMoney = (amount: number): string => {
  const rounded = Math.round(amount);
  return new Intl.NumberFormat('ru-RU').format(rounded) + ' ₽';
};

